module.exports = __webpack_public_path__ + "static/media/Lahore High court c. 1960s.340b03ca.jpg";